import { render, staticRenderFns } from "./viewFrame.vue?vue&type=template&id=255b7cfa&"
import script from "./viewFrame.vue?vue&type=script&lang=js&"
export * from "./viewFrame.vue?vue&type=script&lang=js&"
import style0 from "./viewFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports